import { render } from "./ImpersonateNotification.vue?vue&type=template&id=14e7d0d6"
import script from "./ImpersonateNotification.vue?vue&type=script&lang=js"
export * from "./ImpersonateNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__